<form [formGroup]="carbonForm">
    <div class="w-full flex flex-col items-start p-4">
        <mat-card-header class="justify-center text-xl mb-4 text-center w-full"
            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Carbon Metrics
        </mat-card-header>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
            <div class="flex flex-col space-y-2">
                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Crops (Καλλιέργειες)</h3>
                    <mat-card>
                      <mat-card-content>
                        <div class="grid grid-cols-2 gap-4">
                          <!-- Column 1 - Dropdown -->
                          <div>
                            <label class="text-xs text-gray-600 font-semibold mb-1 block">Crop</label>
                            <select
                              formControlName="crop_type"
                              class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring"
                            >
                              <option *ngFor="let option of dropdownOptions['rsequestration']" [ngValue]="option.label.split('~')[0]">
                                {{ option.label.split('~')[0] }}
                              </option>
                            </select>
                          </div>
                  
                          <!-- Column 2 - Size input -->
                          <div>
                            <label
                              class="text-xs text-gray-600 font-semibold mb-1 block"
                              [innerHTML]="formatLabel('size (ha)')"
                            ></label>
                            <input
                              type="number"
                              formControlName="size"
                              class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring"
                            />
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  
                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Irrigation (Άρδευση)</h3>
                    <mat-card>
                        <mat-card-content>
                            <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                [innerHTML]="formatLabel('energy_consumption (kWh/ha)')"></label>
                            <input type="number" formControlName="energy_consumption"
                                class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring" />
                        </mat-card-content>
                    </mat-card>
                </div>

                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Residues (Υπολείμματα)</h3>
                    <mat-card>
                        <mat-card-content>
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('residues_amount (KG/ha)')"></label>
                                    <input type="number" formControlName="residues_amount"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring" />
                                </div>
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('efresidue (kg CO₂/kg)')"></label>
                                    <select formControlName="efresidue"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring">
                                        <option *ngFor="let option of dropdownOptions['efresidue']"
                                            [ngValue]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Resequestrations (Δέσμευση CO₂)</h3>
                    <mat-card>
                        <mat-card-content>
                            <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                [innerHTML]="formatLabel('rsequestration kgCO₂/ha/year')"></label>
                            <select formControlName="rsequestration"
                                class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring">
                                <option *ngFor="let option of dropdownOptions['rsequestration']"
                                    [ngValue]="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <div class="flex flex-col space-y-6">
                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Fertilization (Λίπανση)</h3>
                    <mat-card>
                        <mat-card-content>
                            <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                [innerHTML]="formatLabel('total_nitrogen (Kg)')"></label>
                            <input type="number" formControlName="total_nitrogen"
                                class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring" />
                        </mat-card-content>
                    </mat-card>
                </div>

                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Fuel (Καύσιμο)</h3>
                    <mat-card>
                        <mat-card-content>
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('fuel_consumption (kgCO₂ /l)')"></label>
                                    <input type="number" formControlName="fuel_consumption"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring" />
                                </div>
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('ef_fuel (kgCO₂ /l)')"></label>
                                    <select formControlName="ef_fuel"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring">
                                        <option *ngFor="let option of dropdownOptions['ef_fuel']"
                                            [ngValue]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div>
                    <h3 class="font-semibold text-sm text-gray-700 mb-1" id="field">Spraying (Φυτοπροστασία)</h3>
                    <mat-card>
                        <mat-card-content>
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('spraying_fuel_consumption (L)')"></label>
                                    <input type="number" formControlName="spraying_fuel_consumption"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring" />
                                </div>
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('spraying_ef_fuel (kgCO₂ /l)')"></label>
                                    <select formControlName="spraying_ef_fuel"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring">
                                        <option *ngFor="let option of dropdownOptions['spraying_ef_fuel']"
                                            [ngValue]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('total_spraying (Kg)')"></label>
                                    <input type="number" formControlName="total_spraying"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring" />
                                </div>
                                <div>
                                    <label class="text-xs text-gray-600 font-semibold mb-1 block"
                                        [innerHTML]="formatLabel('factor_spraying_emissions (kgCO₂/kg)')"></label>
                                    <select formControlName="factor_spraying_emissions"
                                        class="w-full border rounded px-2 py-1 text-sm focus:outline-none focus:ring">
                                        <option *ngFor="let option of dropdownOptions['factor_spraying_emissions']"
                                            [ngValue]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>

        <div class="flex justify-end space-x-2 mt-6 w-full">
            <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
            <button mat-raised-button id="saveButton" (click)="saveCurrentAsLocation()">
                <i class="fa-solid fa-floppy-disk mx-2"></i>Save
            </button>
        </div>
    </div>
</form>